export default class SearchForm {
  constructor(element) {
    this.searchForm = element;
    this.searchInput = this.searchForm.querySelector('[data-search-input]');
    this.searchSubmit = this.searchForm.querySelector('[data-search-submit]');
  }

  init() {
    this.searchInput.addEventListener('input', (event) => {
      const target = event.target;
      this.searchSubmit.disabled = target.value === '';
    });
    return this;
  }
}
